import { axiosInstance } from '@/utils/libs/axios';

export interface IWorkerQCTestRun {
  test_run_id: string;
  test_run_title: string;
  status: string;
}

export interface IWorkerQCProject {
  project_id: string;
  project_title: string;
  test_runs: IWorkerQCTestRun[];
}

export interface IWorkerQCIssue {
  issue_id: string;
  issue_title: string;
  project_id: string;
  project_title: string;
}

export interface IWorkerQC {
  user_id: string;
  full_name: string;
  total_projects: number;
  total_regression_tc: number;
  test_runs: Record<string, number>;
  total_created_issues: number;
  projects: IWorkerQCProject[];
  issues: IWorkerQCIssue[];
}

export interface IWorkerProjectIssue {
  issue_id: string;
  issue_title: string;
  created_by: string;
  created_by_name: string;
}

export interface IWorkerProject {
  project_id: string;
  project_title: string;
  total_test_cases: number;
  total_test_runs: number;
  test_runs: Record<string, number>;
  total_issues: number;
  issues: IWorkerProjectIssue[];
}

export interface IWorkerDashboardResponse {
  period: string;
  qc: IWorkerQC[];
  projects: IWorkerProject[];
}

export const WorkerService = {
  async getDashboard(date?: string): Promise<IWorkerDashboardResponse> {
    const res = await axiosInstance.get<IWorkerDashboardResponse>(
      '/api/worker',
      {
        params: {
          date,
        },
      },
    );

    return res.data;
  },
};
